import { useCachedSsrRef } from "./serverCache.mjs";
import { CategoryPageOfferDocument } from "../graphql/Category.mjs";
import { HomeOffersDocument } from "../graphql/Offers.mjs";
import { isValidOffer, mapHomeOffer } from "../utils/offers.mjs";
import { useQuery } from "villus";
import { computed } from "vue";
function fetchOffers(limit) {
  const { execute, error, isFetching } = useQuery({
    query: HomeOffersDocument.toString(),
    variables: {
      limit
    },
    fetchOnMount: false
  });
  return {
    execute,
    error,
    isFetching
  };
}
function fetchCategoryPageOffer(categoryId) {
  const { execute, data, error, isFetching } = useQuery({
    query: CategoryPageOfferDocument.toString(),
    variables: {
      categoryId
    },
    fetchOnMount: true
  });
  return {
    execute,
    data,
    error,
    isFetching
  };
}
export async function useHomepageOffers(limit = 6, _fetchOffers = fetchOffers) {
  const cachedOffers = useCachedSsrRef(
    "offers",
    []
  );
  const { execute, isFetching } = _fetchOffers(limit);
  const offers = await (async () => {
    if (cachedOffers.value.length) {
      return cachedOffers.value;
    }
    const { data, error } = await execute();
    if (error) {
      throw new Error(error.message);
    }
    cachedOffers.value = (data?.homepage_offers || []).sort(
      (a, b) => Number(a?.sort) - Number(b?.sort)
    );
    return cachedOffers.value;
  })();
  return {
    offers,
    isFetching
  };
}
export function useCategoryOffers(categoryId, _fetchCategoryPageOffer = fetchCategoryPageOffer) {
  const { data, isFetching } = _fetchCategoryPageOffer(categoryId);
  return {
    isFetching,
    offers: computed(
      () => data?.value?.category?.offers?.filter(isValidOffer)?.map(mapHomeOffer)
    )
  };
}
